import { render, staticRenderFns } from "./three_data_list.vue?vue&type=template&id=482d1875&scoped=true&"
import script from "./three_data_list.vue?vue&type=script&lang=js&"
export * from "./three_data_list.vue?vue&type=script&lang=js&"
import style0 from "./three_data_list.vue?vue&type=style&index=0&id=482d1875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d1875",
  null
  
)

export default component.exports